/**
 * TanStack Query hook for fetching user profile analysis data.
 *
 * Similar polling pattern to useAnalysis but for the cross-session
 * user profile endpoint. Polls while processing, stops when ready.
 * @module useUserAnalysis
 */

import { useQuery } from '@tanstack/react-query'
import { analysisService } from '../services/analysisService'

export function useUserAnalysis() {
  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['userAnalysis'],
    queryFn: () => analysisService.getUserAnalysis(),
    staleTime: 5 * 60 * 1000,
    retry: 2,
    refetchInterval: (query) => {
      if (query.state.data?.status === 'processing') return 5000
      return false
    },
  })

  const isProcessing = data?.status === 'processing'
  const needsUpgrade = data?.status === 'upgrade_required'
  const analysis = (isProcessing || needsUpgrade) ? null : data

  return { analysis, isLoading, isProcessing, needsUpgrade, error, refetch }
}
